/* eslint semi:0 */
import { identity } from '../../utils/fn'
import BaseClass from '../../application/BaseClass'
import { adBlockDetectionFinished } from '../../organizedByType/actions/adActions'
import { safeRequest } from '../../utils/mithril'
import { createElement } from '../../utils/dom'
import { getIsDraft } from '../../application/pageDataObject'

class AdblockDetectorProvider extends BaseClass {
  constructor() {
    super()
    !getIsDraft() && this.loadAdblockTestScript()
  }

  loadAdblockTestScript() {
    safeRequest({
      method: 'GET',
      url: 'http://static.90min.com/assets/qa4/ads-adblock-test.js',
      deserialize: identity, //This is simply to avoid the warning that the response is not a JSON
    }).then(this.onAdblockTestScriptLoaded.bind(this), this.onAdblockTestScriptError.bind(this))
  }

  onAdblockTestScriptLoaded() {
    let ad = this.createDummyAd()
    this.adblockDetected = this.isAdHidden(ad)
    this.onAdblockDetectingFinished()
  }

  createDummyAd() {
    let ad = createElement('div')
    ad.id = 'adblock-test'
    ad.setAttribute('class', 'ad-dummy pub_300x250')
    ad.setAttribute(
      'style',
      'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important'
    )
    document.body.appendChild(ad)
    return ad
  }

  isAdHidden(ad) {
    let isHidden = ad.offsetHeight === 0 || ad.offsetWidth === 0
    if (!isHidden && window.getComputedStyle) {
      let adStyle = window.getComputedStyle(ad, null)
      isHidden =
        adStyle.getPropertyValue('display') === 'none' ||
        adStyle.getPropertyValue('visibility') === 'hidden'
    }
    return isHidden
  }

  onAdblockTestScriptError(error) {
    // eslint-disable-line handle-callback-err
    this.adblockDetected = true
    this.onAdblockDetectingFinished()
  }

  onAdblockDetectingFinished() {
    adBlockDetectionFinished({ detected: this.adblockDetected })
  }
}

const initAdblockDetectorProvider = AdblockDetectorProvider.create.bind(AdblockDetectorProvider)
export default initAdblockDetectorProvider



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/ads/adblockDetectorProvider.js